"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var LocalGrid_1 = __importDefault(require("../controls/LocalGrid"));
var constants_1 = require("../controls/Grid/constants");
var recompose_1 = require("recompose");
var reduxFormWrappers_1 = require("./reduxFormWrappers");
var Dialog_1 = __importDefault(require("material-ui/Dialog"));
var Form = function (props) { return react_1.default.createElement("div", null, "Please implement your own redux form "); };
var InlineGrid = function (_a) {
    var dialog = _a.dialog, dialogProps = _a.dialogProps, ActionBar = _a.ActionBar, Form = _a.Form, onSubmit = _a.onSubmit, item = _a.item, closeDialog = _a.closeDialog, props = __rest(_a, ["dialog", "dialogProps", "ActionBar", "Form", "onSubmit", "item", "closeDialog"]);
    return (react_1.default.createElement("div", { style: props.style },
        react_1.default.createElement(LocalGrid_1.default, __assign({ ActionBar: ActionBar }, props)),
        react_1.default.createElement(Dialog_1.default, __assign({}, dialogProps, { open: dialog, onRequestClose: closeDialog }),
            react_1.default.createElement(Form, { closeItem: closeDialog, onSubmit: onSubmit, initialValues: item }))));
};
/**
 * Wrapper around Local grid implementing adding, editing and deleting.
 *
 * Also adds a gridName property, which will override name property if specified.
 */
var ComposedInlineGrid = recompose_1.compose(recompose_1.withStateHandlers({ dialog: false, isNew: false, item: null }, {
    closeDialog: function (state) { return function () { return (__assign({}, state, { dialog: false })); }; },
    openAddDialog: function (state) { return function () { return (__assign({}, state, { dialog: true, isNew: true, item: null })); }; },
    openEditDialog: function (state) { return function (item) { return (__assign({}, state, { dialog: true, isNew: false, item: item })); }; },
}), recompose_1.defaultProps({
    columns: [
        {
            field: 'name',
            label: 'Název',
            type: constants_1.ColumnType.TEXT,
        },
        {
            field: 'active',
            label: 'Aktivní',
            type: constants_1.ColumnType.BOOLEAN,
            width: 100,
        },
    ],
    Form: Form,
    sort: 'name',
}), recompose_1.withHandlers({
    addItem: function (_a) {
        var openAddDialog = _a.openAddDialog;
        return function () {
            openAddDialog();
        };
    },
    editItem: function (_a) {
        var openEditDialog = _a.openEditDialog;
        return function (item) {
            openEditDialog(item);
        };
    },
    deleteItems: function (_a) {
        var onChange = _a.onChange, value = _a.value, onDelete = _a.onDelete;
        return function (checkedItems, dispatch) {
            if (onDelete)
                onDelete(checkedItems);
            onChange(__spread(value.filter(function (i) { return !checkedItems.includes(i); })));
        };
    },
    onSubmit: function (_a) {
        var onChange = _a.onChange, value = _a.value, isNew = _a.isNew, closeDialog = _a.closeDialog, oldItem = _a.item;
        return function (item) {
            if (isNew) {
                onChange(__spread(value, [item]));
            }
            else {
                onChange(__spread(value.filter(function (i) { return i !== oldItem; }), [item]));
            }
            closeDialog();
        };
    },
}), recompose_1.mapProps(function (_a) {
    var gridName = _a.gridName, name = _a.name, rest = __rest(_a, ["gridName", "name"]);
    return (__assign({}, rest, { name: gridName ? gridName : name }));
}))(InlineGrid);
exports.default = ComposedInlineGrid;
exports.FormInlineGrid = reduxFormWrappers_1.formWrapper(ComposedInlineGrid);
//# sourceMappingURL=InlineGrid.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/InlineGrid.js
// module id = 2549
// module chunks = 0